/*
Wrapper around $fetch for authenticated API calls.

It attaches the Passport bearer token (managed by @sidebase/nuxt-auth) to the
Authorization header so the server-side auth middleware can verify the caller.
Use this for every call to a PROTECTED /api/** route. Public auth routes
(/api/auth/login, /forgot, /reset, /onboard, etc...) should keep using plain $fetch.

Note: useAuth().token is a computed ref that already includes the configured
token type prefix (e.g. "Bearer <jwt>"), so we set it on the header as-is.
*/
export function secureFetch(request, options = {}) {
  const { token } = useAuth()

  const headers = new Headers(options.headers || {})
  if (token.value) {
    headers.set('Authorization', token.value)
  }

  return $fetch(request, { ...options, headers })
}
